export default __webpack_public_path__ + "static/media/custom-tools.07597d44.jpg";